// extracted by mini-css-extract-plugin
export default {"depictionBulletItem":"depictionBulletItem__3KjM6"};